exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vs__selected {\n    font-size: .8571em;\n}\n.dropdown-menu {\n    z-index:10030 !important;\n}\n:root {\n    /* Blue */\n    --blue: #3f9ce8 !important;\n    --blue-light: #C8E2F8;\n    --blue-medium: #9ACBF3;\n    --blue-dark: #125A96;\n}\n\n/* --== Scrollbar ==-- */\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n}\n::-webkit-scrollbar-thumb {\n    background: var(--blue-medium);\n    border-radius: 30px;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: var(--blue-dark);\n}\n::-webkit-scrollbar-track {\n    background: white;\n    border-radius: 0px;\n}\n\n", ""]);

// exports
